<template>
  <div class="user-list-container">
    <!-- 筛选条件区域 -->
    <canvas-glass-card title="筛选条件" variant="light" :hoverable="false" class="filter-card">
      <a-form :model="queryForm" label-align="left">
        <a-grid :cols="4" :colGap="26" :rowGap="0" :collapsed="collapsed" :collapsed-rows="1">
          <a-grid-item>
            <a-form-item label="用户名" label-col-flex="60px">
              <a-input v-model="queryForm.username" placeholder="请输入用户名" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="昵称" label-col-flex="60px">
              <a-input v-model="queryForm.nickname" placeholder="请输入昵称" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="状态" label-col-flex="60px">
              <a-select v-model="queryForm.status" placeholder="请选择状态">
                <a-option value="">全部</a-option>
                <a-option value="0">启用</a-option>
                <a-option value="1">禁用</a-option>
              </a-select>
            </a-form-item>
          </a-grid-item>
          <a-grid-item suffix="suffix">
            <a-space>
              <a-button type="primary" @click="handleQuery" :loading="loading">
                <template #icon>
                  <icon-search style="stroke: #fff"/>
                </template>
                搜索
              </a-button>
              <a-button type="primary" status="warning" @click="handleReset">重置</a-button>
              <a-button type="text" @click="()=>{collapsed = !collapsed}">
                <template #icon>
                  <icon-down v-if="collapsed"/>
                  <icon-up v-else/>
                </template>
                {{ collapsed ? '展开' : '收起' }}
              </a-button>
            </a-space>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="手机号" label-col-flex="60px">
              <a-input v-model="queryForm.phone" placeholder="请输入手机号" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
        </a-grid>
      </a-form>
    </canvas-glass-card>

    <a-space/>

    <!-- 用户列表表格 -->
    <canvas-glass-card variant="primary" :hoverable="false" class="table-card">
      <template #header>
        <a-row>
          <a-col flex="200px">
            <span class="glass-card__title">用户信息列表</span>
          </a-col>
          <a-col flex="auto"/>
          <a-col flex="80px">
            <a-row flex="150px">
<!--              <a-button type="primary" @click="addUser()">-->
<!--                <template #icon>-->
<!--                  <icon-plus style="stroke: #fff"/>-->
<!--                </template>-->
<!--                新增-->
<!--              </a-button>-->
              <a-tooltip content="列设置">
                <a-button type="text" @click="showColumnSetting = true">
                  <template #icon>
                    <icon-settings/>
                  </template>
                </a-button>
              </a-tooltip>
              <a-tooltip content="刷新">
                <a-button type="text" @click="fetchTableData">
                  <template #icon>
                    <icon-refresh/>
                  </template>
                </a-button>
              </a-tooltip>
            </a-row>
          </a-col>
        </a-row>
      </template>

      <!-- 用户列表表格 -->
      <a-table
          row-key="id"
          v-bind:columns="visibleColumns"
          :data="pagination.records"
          :pagination="false"
          :loading="loading"
          column-resizable
          stripe
          :bordered="{cell:true}"
          :scroll="{ x: 1000 }"
      >

        <template #type="{ record }">
          {{ getTypeText(record.type) }}
        </template>

        <template #status="{ record }">
          {{ getStatusText(record.status) }}
        </template>

        <template #outsource="{ record }">
          {{ getOutsourceText(record.outsource) }}
        </template>

        <template #locked="{ record }">
          {{ getLockedText(record.locked) }}
        </template>

        <template #createTime="{ record }">
          {{ formatDate(record.createTime) }}
        </template>

        <template #action="{ record }">
          <a-space>
            <!-- 编辑 -->
<!--            <a-button type="text" size="mini" status="normal" @click="editUser(record)" class="button-table-option">-->
<!--              <template #icon>-->
<!--                <icon-edit/>-->
<!--              </template>-->
<!--              编辑-->
<!--            </a-button>-->
            <!-- 重置密码 -->
            <a-button type="text" size="mini" status="warning" @click="resetPasswordBefore(record)"
                      class="button-table-option">
              <template #icon>
                <icon-tool />
              </template>
              重置密码
            </a-button>
            <!-- 更多 -->
            <a-dropdown trigger="click">
              <a-button type="text" size="mini" class="button-table-option">更多</a-button>
              <template #content>
<!--                <a-doption @click="assignRolesBefore(record)">
                  <a-button type="text" size="mini" status="success" class="button-table-option">
                    <template #icon>
                      <icon-user />
                    </template>
                    分配角色
                  </a-button>
                </a-doption>
                <a-doption @click="unbindDeviceBefore(record)">
                  <a-button type="text" size="mini" status="warning" class="button-table-option">
                    <template #icon>
                      <icon-link />
                    </template>
                    小程序设备解绑
                  </a-button>
                </a-doption>
                <a-doption @click="disableUserBefore(record)">
                  <a-button type="text" size="mini" status="warning" class="button-table-option">
                    <template #icon>
                      <icon-unlock v-if="record.status === '1'" />
                      <icon-lock v-else />
                    </template>
                    {{ record.status === '1' ? '启用用户' : '禁用用户' }}
                  </a-button>
                </a-doption>-->
                <a-doption @click="deleteUserBefore(record)">
                  <a-button type="text" size="mini" status="danger" class="button-table-option">
                    <template #icon>
                      <icon-delete/>
                    </template>
                    删除用户
                  </a-button>
                </a-doption>
              </template>
            </a-dropdown>
          </a-space>
        </template>
      </a-table>
      <!-- 分页组件 -->
      <a-pagination
          style="justify-content: end;margin: 10px;"
          v-model:current="pagination.current"
          v-model:page-size="pagination.size"
          :total="pagination.total"
          :page-size-options="[10, 20, 50, 100]"
          show-total
          show-jumper
          show-page-size
          @change="handlePageChange"
          @page-size-change="handlePageSizeChange"
      />
    </canvas-glass-card>

    <!-- 列设置模态框 -->
    <a-drawer
        :visible="showColumnSetting"
        title="列设置"
        @ok="handleColumnSettingOk"
        @cancel="showColumnSetting = false"
        width="300px"
        :mask-closable="false"
        :hide-cancel="true"
    >
      <div class="column-setting">
        <a-checkbox-group v-model="selectedColumns" direction="vertical">
          <a-checkbox
              v-for="column in allColumns"
              :key="column.dataIndex"
              :value="column.dataIndex"
              :disabled="column.required"
          >
            {{ column.title }}
          </a-checkbox>
        </a-checkbox-group>
      </div>
    </a-drawer>

    <!-- 用户重置密码模态框 -->
    <a-modal
        v-model:visible="isShowResetPasswordModal"
        :on-before-ok="resetPassword"
        ok-text="确定"
        @cancel="isShowResetPasswordModal = false"
        draggable
    >
      <a-input-password v-model="userInfoCopy.restPassword" placeholder="请输入密码" />
      <template #title>
        确认重置密码
      </template>
      <div>确定重置[<strong>{{ userInfoCopy.username }}</strong>]密码吗？</div>
    </a-modal>
    <!-- 用户分配角色模态框 -->
    <a-modal
        v-model:visible="isShowAssignRolesModal"
        :on-before-ok="assignRoles"
        ok-text="确定"
        @cancel="isShowAssignRolesModal = false"
        draggable
    >
      <template #title>
        分配角色
      </template>
      <assign-role-modal :user="userInfoCopy"/>
    </a-modal>
    <!-- 小程序设备解绑模态框 -->
    <a-modal
        v-model:visible="isShowUnbindDeviceModal"
        :on-before-ok="unbindDevice"
        ok-text="确定"
        @cancel="isShowUnbindDeviceModal = false"
        draggable
    >
      <template #title>
        确认小程序设备解绑
      </template>
      <div>确定解绑 [<strong>{{ userInfoCopy.username }}</strong>] 吗？</div>
    </a-modal>
    <!-- 用户禁用模态框 -->
    <a-modal
        v-model:visible="isShowDisabledUserModal"
        :on-before-ok="disableUser"
        :ok-text="userInfoCopy.status === '1' ? '启用' : '禁用'"
        @cancel="isShowDisabledUserModal = false"
        draggable
    >
      <template #title>
        是否{{userInfoCopy.status === '1' ? '启用' : '禁用'}}
      </template>
      <div>确定要{{userInfoCopy.status === '1' ? '启用' : '禁用'}}[<strong>{{ userInfoCopy.username }}</strong>]吗？</div>
    </a-modal>
    <!-- 用户删除模态框 -->
    <a-modal
        v-model:visible="isShowDeleteUserModal"
        :on-before-ok="delUser"
        ok-text="删除"
        @cancel="isShowDeleteUserModal = false"
        draggable
    >
      <template #title>
        是否删除
      </template>
      <div>确定要删除[<strong>{{ userInfoCopy.username }}</strong>]吗？</div>
    </a-modal>
  </div>
</template>

<script setup>
import {ref, onMounted, computed} from 'vue'
import {deleteMiniAppDeviceNumber, deleteUser, getUserPage, resetUserPassword, updateUserStatus} from '@/apis/UserApi'
import CanvasGlassCard from '@/components/CanvasGlassCard.vue'
import {
  IconSearch,
  IconDown,
  IconUp,
  IconPlus,
  IconSettings,
  IconRefresh,
  IconEdit,
  IconLock,
  IconDelete
} from '@arco-design/web-vue/es/icon'
import {Message} from "@arco-design/web-vue";
import AssignRoleModal from "@/components/System/User/AssignRoleModal.vue";
import {timestampNumber2dateString} from "@/utils/date-util";

// 条件查询表单折叠
const collapsed = ref(true)

// 是否显示编辑用户模态框
const isShowEditUserModal = ref(false)
// 是否显示重置密码模态框
const isShowResetPasswordModal = ref(false)
// 是否显示分配角色模态框
const isShowAssignRolesModal = ref(false)
// 是否显示小程序设备解绑模态框
const isShowUnbindDeviceModal = ref(false)
// 是否显示禁用用户模态框
const isShowDisabledUserModal = ref(false)
// 是否显示删除用户模态框
const isShowDeleteUserModal = ref(false)
// 用户信息
const userInfoCopy = ref({})

// 筛选条件
const queryForm = ref({
  username: '',
  nickname: '',
  phone: '',
  status: '',
  createTimeRange: []
})

// 用户列表数据
let pagination = ref({
  records: [],
  current: 1,
  size: 10,
  pages: 0,
  total: 0
})
// 加载状态
const loading = ref(false)

// 列设置相关
const showColumnSetting = ref(false)
const selectedColumns = ref([
  'code',
  'username',
  'nickname',
  'phone',
  'email',
  'type',
  'status',
  'outsource',
  'locked',
  'createTime',
  'action'
])

// 所有列定义
const allColumns = ref([
  // { title: 'ID', dataIndex: 'id', width: 80, required: true, },
  {title: '账号编码', dataIndex: 'code', width: 120, required: true, fixed: 'left',},
  {title: '用户名', dataIndex: 'username', width: 120, required: true, fixed: 'left', ellipsis: true, tooltip: true,},
  {title: '昵称', dataIndex: 'nickname', width: 120, ellipsis: true, tooltip: true,},
  {title: '手机号', dataIndex: 'phone', width: 130, ellipsis: true, tooltip: true,},
  {title: '邮箱', dataIndex: 'email', width: 180, ellipsis: true, tooltip: true,},
  {title: '用户类型', dataIndex: 'type', width: 100, slotName: 'type',},
  {title: '状态', dataIndex: 'status', width: 80, slotName: 'status',},
  {title: '是否外包', dataIndex: 'outsource', width: 100, slotName: 'outsource',},
  {title: '账号锁', dataIndex: 'locked', width: 100, slotName: 'locked',},
  {title: '创建时间', dataIndex: 'createTime', width: 180, slotName: 'createTime',},
  {title: '操作', dataIndex: 'action', width: 200, slotName: 'action', align: 'center', fixed: 'right', required: true,}
])

// 可见列计算属性
const visibleColumns = computed(() => {
  return allColumns.value.filter(column => selectedColumns.value.includes(column.dataIndex))
})

// 获取用户列表
const fetchTableData = async () => {
  loading.value = true

  getUserPage({
    ...queryForm.value,
    current: pagination.value.current,
    size: pagination.value.size
  }).then(response => {
    // console.log(response)
    loading.value = false;
    if (response.code === 0) {
      pagination.value = response.data;
      // console.log(pagination.value)
    } else {
      Message.error(response.message);
      console.error('获取用户列表失败:', response)
    }
  }).catch(error => {
    Message.error(error.message)
  })
}

// 搜索用户
const handleQuery = () => {
  pagination.current = 1
  fetchTableData()
}

// 重置筛选条件
const handleReset = () => {
  Object.keys(queryForm.value).forEach(key => {
    queryForm.value[key] instanceof Array ? queryForm.value[key].length = 0 : queryForm.value[key] = ''
  })
  fetchTableData()
}

// 处理页码变化
const handlePageChange = (page) => {
  fetchTableData()
}

// 处理每页数量变化
const handlePageSizeChange = (size) => {
  pagination.current = 1
  fetchTableData()
}

// 列设置相关方法
const handleColumnSettingOk = () => {
  showColumnSetting.value = false
  // 这里可以保存用户的列设置到本地存储
  localStorage.setItem('userListColumns', JSON.stringify(selectedColumns.value))
  Message.success('列设置保存成功')
}

// 格式化方法
const getTypeText = (type) => {
  const map = {'0': '管理员', '1': '员工', '2': '客户账号'}
  return map[type] || '未知'
}


const getStatusText = (status) => {
  const map = {'0': '正常', '1': '禁用', }
  return map[status] || '未知'
}

const getOutsourceText = (outsource) => {
  return outsource ? '是' : '否';
}

const getLockedText = (locked) => {
  return locked ? '是' : '否';
}


const formatDate = (dateString) => {
  // if (!dateString) return '-'
  // const date = new Date(dateString)
  // return date.toLocaleString('zh-CN')
  if (!dateString) return '—';
  // return dateString.substring(0, 16).replace('T', ' ');
  return timestampNumber2dateString(dateString)
}

/**
 * 操作方法
 */
const addUser = (user) => {
  // TODO: 实现新增用户功能
  console.log('新增用户:', user)
}
// 编辑用户
const editUserBefore = (user) => {
  userInfoCopy.value = user
  isShowEditUserModal.value = true
}
const editUser = (user) => {
  // TODO: 实现编辑用户功能
  console.log('编辑用户:', user)
}
// 重置密码
const resetPasswordBefore = (user) => {
  userInfoCopy.value = user
  userInfoCopy.value.restPassword = '123456'
  isShowResetPasswordModal.value = true
}

const resetPassword = async () => {
  console.log('重置密码:', userInfoCopy.value)
  await resetUserPassword(userInfoCopy.value.id,userInfoCopy.value.restPassword)
      .then(response => { 
        if (response.code === 0) {
          Message.success('重置密码成功')
          return true
        } else {
          Message.error("错误:", response.message);
          console.warn("错误:", response.message);
          return false
        }
      })
      .catch(error => {
        Message.error("错误:", error);
        console.warn("错误:", error);
        return false
      })
}
// 分配角色
const assignRolesBefore = (user) => {
  userInfoCopy.value = user
  isShowAssignRolesModal.value = true
}
const assignRoles = (user) => {
  // TODO: 实现分配角色功能
  console.log('分配角色:', user)
}
// 小程序设备解绑
const unbindDeviceBefore = (user) => {
  userInfoCopy.value = user
  isShowUnbindDeviceModal.value = true
}
const unbindDevice = async () => {
  console.log('小程序设备解绑:', userInfoCopy.value)
  await deleteMiniAppDeviceNumber(userInfoCopy.value.id)
      .then(response => {
        if (response.code === 0) {
          Message.success('小程序设备解绑成功')
          fetchTableData()
          return true
        } else {
          Message.error("错误:", response.message);
          console.warn("错误:", response.message);
          return false
        }
      })
      .catch(error => {
        Message.error("错误:", error);
        console.warn("错误:", error);
        return false
      })
}

// 禁用用户
const disableUserBefore = (user) => {
  userInfoCopy.value = user
  isShowDisabledUserModal.value = true
}
const disableUser = async () => {
  if (userInfoCopy.value.status === '0') {
    console.log('禁用用户:', userInfoCopy.value)
  } else {
    console.log('启用用户:', userInfoCopy.value)
  }
  await updateUserStatus(userInfoCopy.value.id, userInfoCopy.value.status)
      .then(response => {
        if (response.code === 0) {
          if (userInfoCopy.value.status === '0') {
            Message.success('禁用用户成功')
          } else {
            Message.success('启用用户成功')
          }
          fetchTableData()
          return true
        } else {
          Message.error("错误:", response.message);
          console.warn("错误:", response.message);
          return false
        }
      })
      .catch(error => {
        Message.error("错误:", error);
        console.warn("错误:", error);
        return false
      })
}
// 删除用户
const deleteUserBefore = (user) => {
  userInfoCopy.value = user
  isShowDeleteUserModal.value = true
}
const delUser = async () => {
  console.log('删除用户:', userInfoCopy.value)
  await deleteUser(userInfoCopy.value.id)
      .then(response => {
        if (response.code === 0) {
          Message.success('删除用户成功')
          fetchTableData()
          return true
        } else {
          Message.error("错误:", response.message);
          console.warn("错误:", response.message);
          return false
        }
      })
      .catch(error => {
        Message.error("错误:", error);
        console.warn("错误:", error);
        return false
      })
}


// 组件挂载时获取数据
onMounted(() => {
  // 从本地存储加载列设置
  const savedColumns = localStorage.getItem('userListColumns')
  if (savedColumns) {
    try {
      selectedColumns.value = JSON.parse(savedColumns)
    } catch (e) {
      console.warn('Failed to parse saved columns:', e)
    }
  }

  fetchTableData()
})
</script>

<style scoped>
.input {
  border: var(--color-text-4) solid 1px;
}

.glass-card__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.4;
}

.button-table-option {
  padding: 0;
}
</style>